import { styled } from '@mui/material'

export const Container = styled('div', {
  shouldForwardProp: (prop) => prop !== 'compact'
})<{ compact?: boolean }>(({ compact }) => ({
  display: 'flex',
  flexDirection: 'column',
  '.react-tel-input, .flag-dropdown': {
    backgroundColor: '#fff !important'
  },
  // SC-10692: a lista de paises abria com altura fixa e estourava a viewport
  // no celular, deixando a busca fora da tela. Limitar pela altura da janela
  // mantem o campo de busca visivel e o scroll dentro da lista.
  '.react-tel-input .country-list': {
    maxHeight: 'min(240px, 40vh)'
  },
  // As bordas ficam aqui (e nao no inputStyle) porque estilo inline nao
  // deixaria o hover e o foco trocarem a cor como nos Textfields.
  ...(compact && {
    '.react-tel-input .form-control': {
      borderColor: 'rgba(0, 0, 0, 0.23)',
      borderRadius: '4px'
    },
    '.react-tel-input .flag-dropdown': {
      borderColor: 'rgba(0, 0, 0, 0.23)',
      borderRadius: '4px 0 0 4px'
    },
    '.react-tel-input:hover .form-control, .react-tel-input:hover .flag-dropdown':
      { borderColor: '#3F403F' },
    '.react-tel-input .form-control:focus': {
      borderColor: '#3F403F',
      boxShadow: 'inset 0 0 0 1px #3F403F'
    },
    // Sem erro, a linha da mensagem vazia so empurrava o campo de baixo.
    '.react-tel-input + .MuiTypography-root:empty': { display: 'none' }
  })
}))
